import { useEffect } from 'react'
import { useForm } from 'formular'
import { debounce } from 'throttle-debounce'
import { useLazyQuery } from 'apollo-client'

import productSearchQuery from './productSearch.graphql'


type Fields = {
  search: string
}

export const useSearchModal = () => {
  const form = useForm<Fields>({
    fields: {
      search: [],
    },
  })
  const [ executeSearch, { data, isFetching, error } ] = useLazyQuery(productSearchQuery)

  useEffect(() => {
    const handleQueryChange = debounce(() => {
      const { search: query } = form.getValues()

      executeSearch({
        variables: {
          input: {
            query,
            pagination: {
              limit: 10,
              offset: 0,
            },
          },
        },
      })
    }, 400)

    form.on('change', handleQueryChange)

    return () => {
      handleQueryChange.cancel()
      form.off('change', handleQueryChange)
    }
  }, [ form, executeSearch ])

  return {
    form,
    error,
    isFetching,
    query: form.fields.search.state.value,
    products: data?.productSearch.products,
  }
}
